import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  data: [],
  oneData: null,
};

export const videoSlice = createSlice({
  name: 'video',
  initialState,
  reducers: {
    getVideos: (state) => {
      state.loading = true;
    },
    addVideo: (state) => {
      state.loading = true;
    },
    updateVideo: (state) => {
      state.loading = true;
    },
    removeVideo: (state) => {
      state.loading = true;
    },
    getOneVideo: (state) => {
      state.loading = true;
    },
    successVideo: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    successOneVideo: (state, action) => {
      state.loading = false;
      state.oneData = action.payload;
    },
    failedVideo: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getVideos,
  addVideo,
  updateVideo,
  removeVideo,
  getOneVideo,
  successVideo,
  successOneVideo,
  failedVideo,
} = videoSlice.actions;

export default videoSlice.reducer;
